import { render, staticRenderFns } from "./VisitStatisticsPeriodMg.vue?vue&type=template&id=073b1bc7&scoped=true"
import script from "./VisitStatisticsPeriodMg.vue?vue&type=script&lang=js"
export * from "./VisitStatisticsPeriodMg.vue?vue&type=script&lang=js"
import style0 from "./VisitStatisticsPeriodMg.vue?vue&type=style&index=0&id=073b1bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b1bc7",
  null
  
)

export default component.exports